export const newRow={
    gatewayType:'',
    merchantId:'',
    paymentKey:'',
    salt:'',
    status: 'ACTIVE',
    isPrimary:true
}

export const paymentGatewayDropdown=[
    {label:'Paytm', value:'Paytm'},
    {label:'HDFC', value:'HDFC'},
    {label:'ICICI', value:'ICICI'},
    {label:'PayU', value:'PayU'},
]
